import { AxiosPromise } from 'axios'
import { AppApiResponseData } from '../types/api'
import http from './http'
import { AuditTrailRequestBody, AuditTrailResData } from '../types/auditTrail'

export function get(
	data: AuditTrailRequestBody
): AxiosPromise<AppApiResponseData<AuditTrailResData>> {
	return http({
		method: 'POST',
		url: `/p/auditTrail/search`,
		data: data,
	})
}
